<template>
  <div :class="[currentLanguage === 'AR' ? 'rtlText' : '']">
    <div class="product-entry product-entry--video-type">
      <div class="product-entry__content">
        <div class="video-type__item">
          <div class="img-wrapper">
            <a :href="product.url" class="play-btn" @click.prevent="openLightbox">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM12 9l12 7-12 7z"/>
              </svg>
            </a>

            <div v-if="product.type != 5">
              <img :src="product.icon_small" :alt="product.title" />
            </div>
            <div v-else>
              <img class="video-thumb" :src="product.icon_small" :alt="product.title" />
            </div>
          </div>

          <div class="item-data">
            <div class="headline">
              <h2>{{ product.title }}</h2>
              <Stars :product="product" v-if="helpers.hasStars == 1" />
            </div>
            <Favourite :product="product" v-if="helpers.hasFavourite == 1" />
            <a @click.prevent="openLightbox" class="product-entry__action-btn" :class="[currentLanguage === 'AR' ? 'rtlText' : '']">
              <span v-if="product.type === 1">{{ $t('button.playGame') }}</span>
              <span v-else-if="product.type === 5">{{ $t('button.playVideo') }}</span>
              <span v-else>{{ $t('button.download') }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <FsLightbox
      :toggler="lightboxToggler"
      :sources="[product.url]"
      :types="[product.type === 5 ? 'video' : 'image']"
      :captions="[product.title]"
    />
  </div>
</template>

<script>
import { helpers } from '../helper/portal_config'
import Stars from '@/components/Stars'
import Favourite from '@/components/Favourite'
import FsLightbox from 'fslightbox-vue'

export default {
  name: 'ProductDetailsVideo',
  props: { product: Object },
  components: { Stars, Favourite, FsLightbox },
  data() {
    return {
      helpers,
      currentLanguage: '',
      lightboxToggler: false,
    }
  },
  created() {
    this.currentLanguage = this.$i18n?.locale?.toUpperCase?.() || 'EN'
  },
  methods: {
    openLightbox() {
      this.lightboxToggler = !this.lightboxToggler
    }
  }
}
</script>

<style scoped>
.video-thumb {
  object-fit: contain;
  width: 100% !important;
  object-position: 40px 18%;
}
</style>
